import { createSelector } from '@reduxjs/toolkit';

import { cardsSelector, sortedCardsSelector } from '@lootboy/lib/slices/cards';

import { cardFiltersName } from '~/redux/slices/cardFilters/slice';

export const cardsFilterSelector = ({ [cardFiltersName]: cardsFilters }) =>
  cardsFilters;
export const cardsFilterSelectedSelector = createSelector(
  cardsFilterSelector,
  ({ filters, search, ...rest }) => {
    const filterSelected = Object.values(filters).some(Boolean);

    return {
      ...rest,
      filters,
      search,
      filterSelected,
      filtersActive: filterSelected || Boolean(search),
    };
  },
);

export const cardsFilteredSelector = createSelector(
  sortedCardsSelector,
  cardsFilterSelectedSelector,
  cardsSelector,
  (
    { sorted, unsorted },
    { search, filters, filtersActive, filterSelected },
    { totalRecords, ...rest },
  ) => {
    let items;
    if (!filtersActive) {
      items = [...sorted, ...unsorted];
    } else {
      const checkingFunction = ({ _id }) => filters[_id];
      items = sorted.filter(
        ({ cardTemplate: { name, genres, platforms, types } }) => {
          if (search && !name.toLowerCase().includes(search.toLowerCase())) {
            return false;
          }
          if (filterSelected) {
            return (
              genres.some(checkingFunction) ||
              platforms.some(checkingFunction) ||
              types.some(checkingFunction)
            );
          }
          return true;
        },
      );
    }

    return {
      ...rest,
      totalRecords,
      hasMore: !filtersActive && items.length < totalRecords,
      items,
    };
  },
);
